module.exports = __webpack_public_path__ + "static/media/pm.71a02434.png";